<template>
    <div class="page-header align-items-start min-vh-screen mbr-profile">
      <span class="mask bg-white"></span>
      <div class="container p-0">
        <div class="row">
          <div class="col-lg-12 col-md-8 col-12 mx-auto" style="padding-left: 0px; padding-right: 0px;">
            <div class="card-body" style="padding: 0rem 0rem">
              <div>
                <header class="mbr-profile__bar">
                  <button type="button" class="mbr-profile__back" :aria-label="$t('common.back')" @click="backToHome()">
                    <i class="material-icons-round" aria-hidden="true">chevron_left</i>
                  </button>
                  <h1 class="mbr-profile__title">{{ $t('profile.my_profile') }}</h1>
                </header>
                <!-- <div class="row d-flex justify-content-center">
                  <ul class="reward-tab" :style="styleObject">
                    <li
                      class="nav-item active"
                      id="nav_item_1"
                      @click="changeTab(1)"
                      :style="`color: ${this.$store.state.labelColor} !important`"
                    >
                      <strong>Personal Info</strong>
                    </li>
                    <li
                      class="nav-item"
                      id="nav_item_2"
                      @click="changeTab(2)"
                      :style="`color: ${this.$store.state.labelColor} !important`"
                    >
                      <strong>Preference</strong>
                    </li>
                  </ul>
                </div> -->
                <div>
                  <div class="wrap-card ps-1 pe-1">
                      <div v-if="typeChecked == 1">
                        <profile :propValue="valueFromParent"/>
                      </div>
                      <div v-if="typeChecked == 2">
                        <div class="col-lg-7 col-md-12 col-12 mx-auto mx-2 my-2">
                          <div class="card-custom-new ps-3 pe-3" style="height: 100%;">
                            <div class="font-weight-bolder text-dark title-share-profile">
                                {{ $t('profile.share_preference') }}
                            </div>
                            <div  v-for="(value, key) in memberPreferenceData" :key="key" class="row mt-4">
                                <div class="col-5" style="align-self: center;">
                                    {{ key+1 +" : "+value.name }}
                                </div>
                                <div class="col-7">
                                  <Multiselect @change="changeMemberPreference($event, value.id)" v-model="value.value_selected" :options="value.value_select" :placeholder="$t('profile.value')" label="label" :canClear="false" />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2">
          <material-snackbar
            v-if="snackbar === 'danger' || snackbar === 'success'"
            title=""
            date=""
            :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
        </div>
      </div>
      <material-loading :active="loaderActive" />
      
    </div>
  </template>
  
  <script>
  import { mapMutations, mapActions, mapState } from "vuex";
  import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
  import "bootstrap/dist/js/bootstrap.bundle";
  import MaterialLoading from "@/components/MaterialLoading.vue";
  import "bootstrap/js/dist/modal";
  import $ from "jquery";
  import Profile from '../views/Profile.vue'
  import Multiselect from "@vueform/multiselect";
  import "@vueform/multiselect/themes/default.css";
  import MemberService from "../services/member.service";
  import MemberPreferenceService from "../services/memberPreference.service";
  import { getMerchantCode } from "@/config/utils";
  import { errorMessage } from "@/utils/errorMessage";

  export default {
    name: "my-profile",
    components: {
      MaterialSnackbar,
      MaterialLoading,
      Profile,
      Multiselect
    },
    data() {
      return {
        snackbar: null,
        loaderActive: false,
        merchantCode: "",
        typeChecked: 1,
        memberId: 0,
        valueFromParent: 'default_value'
      };
    },
    // Mobile-only screen like the design: hide the sidenav and top navbar (same toggles as SignIn)
    beforeMount() {
      this.toggleEveryDisplay();
      this.toggleHideConfig();
    },
    beforeUnmount() {
      this.toggleEveryDisplay();
      this.toggleHideConfig();
    },
    created() {
      this.getMemberInfo();
      this.changeTab(1);
    },
    computed: {
      styleObject() {
        return {
          "--label-color": this.$store.state.labelColor,
        };
      },
    },
    mounted() {},
    methods: {
      ...mapMutations([
        "toggleEveryDisplay",
        "toggleHideConfig",
        "navbarMinimize",
      ]),
      ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),
      ...mapState(["isPinned"]),
  
      closeSnackbar() {
        this.snackbar = null;
      },

      backToHome() {
        const code = getMerchantCode();
        this.$router.push((code ? `/${code}` : "") + "/home");
      },

      setTimeOutNotification() {
        setTimeout(() => {
          this.snackbar = null;
        }, 3000);
      },
  
      changeTab(type) {
        if(type == 2) {
          this.valueFromParent = Math.random();
          setTimeout(() => {
            $(".nav-item").removeClass("active");
            $("#nav_item_" + type).addClass("active");
            this.typeChecked = type;
          }, 500);
        } else {
          $(".nav-item").removeClass("active");
          $("#nav_item_" + type).addClass("active");
          this.typeChecked = type;
        }
      },
  
      showLoader() {
        this.loaderActive = true;
      },
      hideLoader() {
        this.loaderActive = false;
      },
      getMemberInfo() {
          MemberService.getProfile().then(
              (response) => {
                  this.memberId = response.data.data.id;
                  this.getMembePreference(response.data.data.id);
              },
              (error) => {
                  console.log(error);
              }
          );
      },
      getMembePreference(memberId) {
        this.isLoadData = false;
        this.showLoader();
        MemberPreferenceService.getListDropdown(memberId).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.memberPreferenceData = response.data.data;
              this.isLoadData = true;
            } else {
              this.snackbar = "danger";
              this.message = errorMessage(response.data.result.message);
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = errorMessage(error);
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      },
      changeMemberPreference(value_select_id, id) {
        if(value_select_id && id) {
            var memberId = this.memberId;
            this.isLoadData = false;
            this.showLoader();
            MemberPreferenceService.changeMemberPreference({memberId, minty_merchant_preference_value_id: value_select_id, minty_merchant_preference_id: id}).then(
            (response) => {
                if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = this.$t("profile.update_preference_success");
                this.setTimeOutNotification();
                this.getMembePreference(memberId);
                this.isLoadData = true;
                } else {
                this.snackbar = "danger";
                this.message = errorMessage(response.data.result.message);
                this.setTimeOutNotification();
                }
                this.hideLoader();
            },
            (error) => {
                this.snackbar = "danger";
                this.message = errorMessage(error);
                this.hideLoader();
                this.setTimeOutNotification();
            }
            );
        }
      },
    },
  };
  </script>
  <style scoped>
  .title-share-profile {
    font-size: 13px;
    font-weight: 600;
  }

  .page-header .container {
    z-index: unset !important;
  }

  .page-header .mask {
    z-index: -1 !important;
  }

  /* Material Dashboard's `.page-header { overflow: hidden }` would stop Profile's Save bar sticking;
     clip still hides the .row's -12px gutter without becoming a scroll container */
  .mbr-profile.page-header {
    overflow: visible;
    overflow-x: clip;
  }

  /* Mobile column like the design (and SignIn): header, form and the sticky Save bar stay 440px wide on large screens */
  .mbr-profile .container {
    max-width: 440px;
    margin: 0 auto;
  }

  .mbr-profile .mask {
    background: var(--mbr-color-canvas) !important;
    opacity: 1;
  }

  .mbr-profile__bar {
    display: flex;
    align-items: center;
    gap: 12px;
    /* margin cancels the -12px gutter of the .row this header sits in */
    margin: 0 12px;
    padding: 24px 24px 12px;
  }

  .mbr-profile__back {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    color: var(--mbr-color-ink-headline);
    box-shadow: var(--mbr-shadow-card);
    transition: transform 0.15s ease;
  }

  .mbr-profile__back:active {
    transform: scale(0.95);
  }

  .mbr-profile__back .material-icons-round {
    font-size: 22px;
  }

  /* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
  .mbr-profile__title {
    margin: 0;
    font-family: var(--mbr-font-headline);
    font-size: 24px;
    font-weight: 800;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: var(--mbr-color-ink-headline);
  }

  .btn-exchange {
    color: rgb(248, 37, 37);
    font-weight: 700;
    border: 1px solid rgb(248, 37, 37);
  }
  
  .reward-tab {
    margin: 0px !important;
    padding: 0px;
    width: 90% !important;
  }
  
  .reward-tab li {
    list-style: none;
    float: left;
    width: 50%;
    text-align: center;
    padding: 5px;
    cursor: pointer;
  }
  
  .reward-tab li.active {
    border-bottom: 2px solid var(--label-color);
    color: var(--label-color);
  }

  @media only screen and (max-width: 600px) {
    .wrap-card .card-item:last-child {
      margin-bottom: 80px !important;
    }
  }
  </style>